/**
 * Host-aware product naming. Only mention ServiceFlow on serviceflow-pro.com hosts.
 */
export function isServiceFlowHost(hostname = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  const host = (hostname || '').toLowerCase()
  return host === 'serviceflow-pro.com' || host.endsWith('.serviceflow-pro.com')
}

export function productName(): string {
  return 'Messenger AI'
}

export function messengerWebhookBase(hostname = typeof window !== 'undefined' ? window.location.origin : ''): string {
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin.replace(/\/+$/, '')
  }
  return (hostname || 'https://messenger.serviceflow-pro.com').replace(/\/+$/, '')
}

export function landingCopy(hostname?: string): {
  heroSupport: string
  featureStandalone: string
  showServiceFlowCta: boolean
  serviceFlowCtaLabel: string
  serviceFlowCtaHref: string
  metaDescription: string
} {
  if (isServiceFlowHost(hostname)) {
    return {
      heroSupport:
        'Sign up, connect your Page in one click, upload your FAQ knowledge base, and let AI answer customers — without a full ServiceFlow subscription.',
      featureStandalone: 'Standalone — no full ServiceFlow subscription required',
      showServiceFlowCta: true,
      serviceFlowCtaLabel: 'Already on ServiceFlow?',
      serviceFlowCtaHref: 'https://app.serviceflow-pro.com/settings/integrations',
      metaDescription:
        'Buy Meta Messenger AI for $20/month. One-click Facebook connect, FAQ knowledge base, AI auto-replies — no ServiceFlow subscription required.',
    }
  }

  return {
    heroSupport:
      'Sign up, connect your Page in one click, upload your FAQ knowledge base, and let AI answer customers around the clock.',
    featureStandalone: 'Standalone product — signup, connect, and go',
    showServiceFlowCta: false,
    serviceFlowCtaLabel: '',
    serviceFlowCtaHref: '',
    metaDescription:
      'Buy Meta Messenger AI for $20/month. One-click Facebook connect, FAQ knowledge base, and AI auto-replies.',
  }
}
